import { render, staticRenderFns } from "./PreviewMethod.vue?vue&type=template&id=70ea88f5&scoped=true&"
import script from "./PreviewMethod.vue?vue&type=script&lang=js&"
export * from "./PreviewMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea88f5",
  null
  
)

export default component.exports